import { useSelector } from "react-redux";
import { PermitsContact } from "../types/PermitsContact";
import identity from "../../../selectors/identity";
import { getCamel } from "../../../utils/functions";
import usePermit from "./permits/usePermit";

interface IUseUserPermitContactProps {
  permitId: string | number;
}

export default function useUserPermitContact({ permitId }: IUseUserPermitContactProps) {
  const permitQuery = usePermit({ permitId: permitId });
  const userId: string = useSelector(identity.getUserId);

  const contacts = getCamel<PermitsContact[]>(permitQuery.data, "data.attributes.permits-contacts", []);
  const userContact = contacts.find((contact: PermitsContact) => contact.userId?.toString() === userId.toString());

  return {
    isContactOnPermit: !!userContact,
    contact: userContact,
    loading: permitQuery.isLoading,
  };
}
